import openSocket from 'socket.io-client';

export function socketConnection(token: string) {
    return openSocket(import.meta.env.VITE_REACT_APP_SOCKET_URL as string, {
        transports: ['websocket'],
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 15000,
        reconnectionDelayMax: 60000,
        randomizationFactor: 1,
        timeout: 45000,
        auth: {
            token
        }
    });
}
